/*!
 * hmac.js - hmac for bcrypto
 * Copyright (c) 2016-2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 * Parts of this software based on hash.js.
 */
'use strict';

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var assert = require('bsert');
/**
 * HMAC
 */


var HMAC = /*#__PURE__*/function () {
  /**
   * Create an HMAC.
   * @param {Function} Hash
   * @param {Number} size
   * @param {Array} [x=[]]
   * @param {Array} [y=[]]
   */
  function HMAC(Hash, size) {
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, HMAC);

    assert(typeof Hash === 'function');
    assert(size >>> 0 === size);
    assert(Array.isArray(x));
    assert(Array.isArray(y));
    this.hash = Hash;
    this.size = size;
    this.x = x;
    this.y = y;
    this.inner = new Hash();
    this.outer = new Hash();
  }
  /**
   * Initialize HMAC context.
   * @param {Buffer} data
   */


  _createClass(HMAC, [{
    key: "init",
    value: function init(key) {
      var _this$inner, _this$outer;

      assert(Buffer.isBuffer(key)); // Shorten key

      if (key.length > this.size) {
        var Hash = this.hash;
        var h = new Hash();
        h.init.apply(h, _toConsumableArray(this.x));
        h.update(key);
        key = h.final.apply(h, _toConsumableArray(this.y));
        assert(key.length <= this.size);
      } // Pad key


      var pad = Buffer.allocUnsafe(this.size);

      for (var i = 0; i < key.length; i++) {
        pad[i] = key[i] ^ 0x36;
      }

      for (var _i = key.length; _i < pad.length; _i++) {
        pad[_i] = 0x36;
      }

      (_this$inner = this.inner).init.apply(_this$inner, _toConsumableArray(this.x));

      this.inner.update(pad);

      for (var _i2 = 0; _i2 < key.length; _i2++) {
        pad[_i2] = key[_i2] ^ 0x5c;
      }

      for (var _i3 = key.length; _i3 < pad.length; _i3++) {
        pad[_i3] = 0x5c;
      }

      (_this$outer = this.outer).init.apply(_this$outer, _toConsumableArray(this.x));

      this.outer.update(pad);
      return this;
    }
    /**
     * Update HMAC context.
     * @param {Buffer} data
     */

  }, {
    key: "update",
    value: function update(data) {
      this.inner.update(data);
      return this;
    }
    /**
     * Finalize HMAC context.
     * @returns {Buffer}
     */

  }, {
    key: "final",
    value: function final() {
      var _this$inner2, _this$outer2;

      this.outer.update((_this$inner2 = this.inner).final.apply(_this$inner2, _toConsumableArray(this.y)));
      return (_this$outer2 = this.outer).final.apply(_this$outer2, _toConsumableArray(this.y));
    }
  }]);

  return HMAC;
}();
/*
 * Expose
 */


module.exports = HMAC;